<template>
    <li class="Photo">
        <figure class="Photo__container">
            <img alt="" :id="'thumbnail-' + photo.id" class="Photo__source" :src="parkphoto.image" @click="selectThisPhoto(photo)"/>
        </figure>
    </li>
</template>

<script>

    export default {
        name: "photo",

        props: ['photo', 'startphoto'],

        data() {
            return {
                parkphoto: {
                    enabled: false,
                    image: this.$props.photo['images'][320],
                    srcPrev: null,
                    src: this.$props.photo['images'][1100] + '?new=' + Date.now(),
                },
            }
        },

        mounted()
        {
            if (this.$props.startphoto !== undefined && ((this.$props.startphoto.photo_id === this.$props.photo.id) || (this.$props.startphoto.photoId === this.$props.photo.id))) {
                this.selectThisPhoto(this.$props.photo);
            }
        },
        methods: {
            selectThisPhoto(photo) {
                this.$store.commit("changeSelectedPhoto", photo);
            }
        },
    }
</script>

<style scoped lang="scss">
.Photo {
    list-style-type: none;
    flex: 0 1 50%;
    @media screen and (min-width: 520px) {
        flex: 0 1 33%;
    }
    @media screen and (min-width: 767px) {
        flex: 0 1 25%;
    }
    @media screen and (min-width: 992px) {
        flex: 0 1 25%;
    }
}

.Photo__container {
    display: block;
}
.Photo__source {
    box-shadow: 0 0 10px rgba(0,0,0,0.25);
    border: 1px solid #ddd;
    &:hover {
        box-shadow: 0 0 6px rgba(0,0,0,0.4);
        cursor: pointer;
    }
}
.Photo_source {
    display: block;
    max-width: 100%;
}

.Photo__container {
    margin: 8px;
}
</style>
